<template>
  <div>
    <div class="radio-inline">
      <input :id="`${$attrs.id}-yes`" type="radio" :value="true"
             v-model.sync="localValue" v-bind="$attrs"
             :disabled="disabled">
      <label :for="`${$attrs.id}-yes`">Yes</label>
    </div>
    <div class="radio-inline">
      <input :id="`${$attrs.id}-no`" type="radio" :value="false"
             v-model.sync="localValue" v-bind="$attrs"
             :disabled="disabled">
      <label :for="`${$attrs.id}-no`">No</label>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import localValueEmissionMixin from "../mixins/localValueEmissionMixin";

  export default Vue.extend({
    inheritAttrs: false,
    mixins: [
      localValueEmissionMixin,
    ],
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
    },
  });
</script>